import * as React from 'react';
import { IOptions } from './';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import { appIndexUri } from 'kts-platform-frame/entry/configUtils';
import AppSdk from 'kts-platform-frame/appSdk';
import { Spin } from 'antd';

const css = require('./UI.AppContainer.scss');

/** Props接口 */
interface IAppContainerProps {
    appInfo: IAppInfo;
    options: IOptions;
}

class IAppContainerState {
    /** 是否加载完成 */
    public isLoad: boolean = false;
}

/** APP显示 */
export default class UIAppContainer extends React.PureComponent<IAppContainerProps, IAppContainerState> {

    state = new IAppContainerState();

    componentDidMount() {
        AppSdk.instance.initialization();
    }

    render() {
        const appInfo = this.props.appInfo;
        const app = this.props.options;
        const appUrl = appInfo.appIndexUri || appIndexUri(app.appKey);
       
        return (
            <div className={css.iframe}>
                {
                    !this.state.isLoad && <Spin className={css.spin} tip="正在努力为你加载中" />
                }
                <iframe style={this.iframeStyle} onLoad={() => { this.setState({ isLoad: true }); }} src={appUrl} />
            </div>
        );
    }

    private get iframeStyle() {
        if (this.state.isLoad) {
            return null;
        } else {
            return { display: 'none' };
        }
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/appSdk/openApp/UI.AppContainer.tsx